import notify from "./notify";

export default (error, component, info) => {
  const componentTag = component && component.$vnode && component.$vnode.tag;   
  notify(error, {  context: {  componentTag, info, origin: "vue-js-packs" } });
};
